module.exports = __webpack_public_path__ + "img/scenery-14.15612496.png";